import urlJoin from 'url-join';
import {
	simpleObjectToStr,
	decodeStepParamAdvancedVal,
	encodeStepParamAdvancedVal,
	setTextStyles,
	strToSimpleObject
} from '../../../../includes/assets/js/modules/dpitUtilsInc';
import DpTinyMceDialog from '../../../../includes/assets/js/modules/DpTinyMceDialog';

import {
	isUrlVariableProcessingEnabled,
} from './dp-admin-utils';

import DpWpLink from '../../../../includes/assets/js/modules/DpWpLink';
import AcfTableHtmlComps from './AcfTableHtmlComps';
import ContainerDragger from './ContainerDragger';
import { getWinBB } from '../../../../public/assets/js/modules/dpitUtilsPublic';
const autosize = require('autosize');


export default class AcfTableField {
	allowedColumnsIdx = [];

	constructor(config, onFirstStepUrlChanged, onRowAdded) {
		if (config.dpDebugEn) console.log('[dpit] INIT ACFTableField config:', config);
		this.config = config;
		this.jBody = $('body');
		this.onFirstStepUrlChangedCb = onFirstStepUrlChanged;
		this.onRowAdded = onRowAdded;
		this.var = {
			ajax: false,
			columIds: [],
		};
		this.state = {
			current_cell_obj: false,
			cell_editor_last_keycode: false
		};

		this.version = config.version ? config.version : '1.4.0';
		if (config.dpWpLink) {
			this.dpWpLink = new DpWpLink(config.dpWpLink);
			this.dpWpLink.open(null, null, true);
		}


		this.tableHtml = new AcfTableHtmlComps(this.config);


		this.jBody.on('click blur', '.acf-table-body-cont--checkbox .acf-table-body-cont-sub', (e) => {
			const that = $(e.target).closest('.acf-table-body-cont--checkbox .acf-table-body-cont-sub');
			this.state.current_cell_obj = $(that.closest('.acf-table-body-cell')[0]) || false;
			if (!that.parent('.acf-cell-eci-wrap').length) {
				const jExtraCont = this.state.current_cell_obj.find('.acf-table-cell-ec');
				if ($(that[0]).is(':checked')) jExtraCont.removeClass('acf-table-cell-ec--hidden');
				else jExtraCont.addClass('acf-table-cell-ec--hidden');
			}
			this.rebuild_table_data(that);
		});


		$('body').on('click', '#dp_wp-link-submit', (e) => {
			if (this.state.current_cell_obj && this.dpWpLink) {

				const activeLinkCell = this.state.current_cell_obj.find('.acf-table-body-cont')[0];
				if (activeLinkCell) {
					this.triggerChangeEventOnAcfTableRoot(activeLinkCell);
					const linkAttrs = this.dpWpLink.getAttrs();
					const { href, jSubEl, isFirstStep } = linkAttrs;
					const row = this.state.current_cell_obj.closest('.acf-table-body-row').find('.acf-table-body-left .acf-table-body-cont').text();

					if (jSubEl && jSubEl.length) jSubEl.text(href || '');
					else if (isFirstStep) {
						const jUl = this.state.current_cell_obj.find('.acf-table-body-cont').find('ul');
						if (jUl.length) {
							jUl.append(this.tableHtml.body_cell_link_sub_item(href));
						}
					} else $(activeLinkCell).text(href || '');

					if (row == '1') {
						if (linkAttrs.urlVarExamples) {
							$('.acf-field[data-name="url_vars_examples"] textarea').val(simpleObjectToStr(linkAttrs.urlVarExamples, '\n'));
						}
						if (this.onFirstStepUrlChangedCb instanceof Function) this.onFirstStepUrlChangedCb();
					}


					this.rebuild_table_data(activeLinkCell);
				}
			}
			// trap any events
			e.preventDefault ? e.preventDefault() : e.returnValue = false;
			e.stopPropagation();
			return false;
		});

		this.jBody.on('click', '.acf-table-body-cont--select .acf-table-body-cont-sub', (e) => {
			const that = $(e.target).closest('.acf-table-body-cont--select .acf-table-body-cont-sub');
			this.state.current_cell_obj = $(that.closest('.acf-table-body-cell')[0]) || false;
			this.rebuild_table_data(that);
		});
		this.init();
	}

	triggerChangeEventOnAcfTableRoot(targetElement) {
		$(targetElement).closest('.acf-field-table').trigger('change');
		this.isChange = true;
	}

	init() {
		this.each_table();
		this.table_add_row_event();
		this.table_remove_row();
		this.table_add_link();
		this.table_remove_link();
		this.simple_cell_editor();
		this.link_editor();
		this.tmce_cell_editor();

		this.prevent_cell_links();
		this.sortable_row();
		this.ui_event_ajax();
		this.editor_custom_style();
	}

	ui_event_ajax() {
		$(document).ajaxComplete(() => {
			this.each_table();
		});
	}

	ui_init_drag_to_scroll() {
		this.containerDraggers = {};
		$('.acf-table-wrap').each((_, element) => {
			this.containerDraggers[element] = new ContainerDragger(
				element,
				'.acf-table-header-cell,.acf-table-body-cell',
				['input', 'textarea', '.dpit-info-icon', '.dpit-table-pro-link', '.acf-table-body-cell:not(.acf-table-body-cell--checkbox) .acf-table-body-cont']
			);
		});
	}


	each_table() {
		$('.acf-field-table .acf-table-root').not('.acf-table-rendered').each((_, element) => {
			const p = {};
			p.obj_root = $(element);
			const table = p.obj_root.find('.acf-table-wrap');

			if (table.length > 0) {
				return;
			}

			p.obj_root.addClass('acf-table-rendered');

			this.data_get(p);

			this.data_default(p);

			this.field_options_get(p);

			this.table_render(p);

			this.misc_render(p);

			if (typeof p.data.b[1] === 'undefined' && typeof p.data.b[0][1] === 'undefined' && p.data.b[0][0].c === '') {
				p.obj_root.find('.acf-table-remove-col').hide();
				p.obj_root.find('.acf-table-remove-row').hide();
			}
			if (this.containerDraggers && this.containerDraggers[element]) {
				this.containerDraggers[element].refresh();
			}
		});
	}

	field_options_get(p) {
		try {
			p.field_options = $.parseJSON(decodeURIComponent(p.obj_root.find('[data-field-options]').data('field-options')));
		} catch (e) {
			p.field_options = {
				use_header: 2,
			};

			console.log('The tablefield options value is not a valid JSON string:', decodeURIComponent(p.obj_root.find('[data-field-options]').data('field-options')));
			console.log('The parsing error:', e);
		}
	}


	data_get(p) {
		// DATA FROM FIELD {

		const val = p.obj_root.find('input.table').val();

		p.data = false;

		// CHECK FIELD CONTEXT {

		if (p.obj_root.closest('.acf-fields').hasClass('acf-block-fields')) {
			p.field_context = 'block';
		} else {
			p.field_context = 'box';
		}

		// }

		if (val !== '') {
			try {
				if (p.field_context === 'box') {
					p.data = $.parseJSON(decodeURIComponent(val.replace(/\+/g, '%20')));
				}

				if (p.field_context === 'block') {
					p.data = $.parseJSON(decodeURIComponent(val.replace(/\+/g, '%20')));
				}
			} catch (e) {
				if (p.field_context === 'box') {
					console.log('The parsing error:', e);
					console.log('The tablefield value is not a valid JSON string:', decodeURIComponent(val.replace(/\+/g, '%20')));
				}

				if (p.field_context === 'block') {
					console.log('The parsing error:', e);
					console.log('The tablefield value is not a valid JSON string:', decodeURIComponent(val.replace(/\+/g, '%20')));
				}
			}

			if (typeof p.data.p !== 'object') {
				console.log('The tablefield value is not a tablefield JSON string:', p.data);

				p.data = false;
			}
		}

		return p.data;

		// }
	}

	data_default(p) {
		// DEFINE DEFAULT DATA {

		p.data_defaults = {

			acftf: {
				v: this.version,
			},

			p: {
				o: {
					uh: 0, // use header
				},
				ca: '', // caption content
			},

			// from data-colparam

			c: [
				{
					c: '',
				},
			],

			// header

			h: [
				{
					c: '',
				},
			],

			// body

			b: [
				[
					{
						c: '',
					},
				],
			],
		};

		// }

		// MERGE DEFAULT DATA {

		if (p.data) {
			const typePDB = typeof p.data.b;
			if (typePDB === 'array') {
				$.extend(true, p.data, p.data_defaults);
			}
		} else {
			p.data = p.data_defaults;
		}

		// }
	}

	table_render(p) {
		// TABLE HTML MAIN {

		p.obj_root.find('.acf-table-wrap').remove();
		p.obj_root.append(this.tableHtml.table);

		// }

		// TABLE GET OBJECTS {

		p.obj_table = p.obj_root.find('.acf-table-table');
		p.obj_top_row = p.obj_root.find('.acf-table-top-row');
		p.obj_top_insert = p.obj_top_row.find('.acf-table-top-right');
		p.obj_header_row = p.obj_root.find('.acf-table-header-row');
		p.obj_header_insert = p.obj_header_row.find('.acf-table-header-right');
		p.obj_bottom_row = p.obj_root.find('.acf-table-bottom-row');
		p.obj_bottom_insert = p.obj_bottom_row.find('.acf-table-bottom-right');

		// }

		// TOP CELLS {

		if (p.data.c) {
			for (var i in p.data.c) {
				p.obj_top_insert.before(this.tableHtml.top_cell);
			}
		}

		this.table_top_labels(p);

		// }

		// HEADER CELLS {

		if (p.data.h) {
			for (i in p.data.h) {
				const definitionId = p.data.h[i].v.replace(/xxx&quot/g, '"').trim();
				let headerCellLabels = p.data.h[i].c.replace(/xxx&quot/g, '"').trim();
				this.var.columIds.push(definitionId);
				let extraClass = '';

				if (Object.keys(this.config.stepDefinitions).includes(definitionId) && !this.config.stepDefinitions[definitionId]?.hide) {
					const definition = this.config.stepDefinitions[definitionId];
					if (definition) {
						this.allowedColumnsIdx.push(Number(i));
						headerCellLabels = definition.title;
					}
				} else {
					extraClass = 'dp-hidden';
				}
				p.obj_header_insert.before(this.tableHtml.header_cell(headerCellLabels, extraClass, definitionId));
			}
		}

		// }

		// BODY ROWS {

		if (p.data.b) {
			for (i in p.data.b) {
				p.obj_bottom_row.before(this.tableHtml.body_row.replace('<!--ph-->', parseInt(i) + 1));
			}
			$('.acf-table-sort-row-icon').load(urlJoin(this.config.assetsUrl, '/icons/arrows-alt-v-solid.svg')).addClass('acf-table-sort-row-icon--loaded').fadeIn(700);
		}

		// }

		// BODY ROWS CELLS {

		const body_rows = p.obj_root.find('.acf-table-body-row');
		let row_i = 0;

		if (body_rows) {
			body_rows.each((_, element) => {
				const body_row = $(element);
				const row_insert = body_row.find('.acf-table-body-right');

				for (i in p.data.b[row_i]) {
					let cellData = p.data.b[row_i][i].c;
					if (cellData) cellData = p.data.b[row_i][i].c.replace(/xxx&quot/g, '"');
					row_insert.before(this.get_column_html(Number(i), cellData, row_i, body_row));
				}

				row_i += 1;
			});
		}

		// }
	}

	get_column_html(colIdx, data, rowIdx, jRow) {
		const columnId = this.var.columIds[colIdx];
		const stepDef = this.config.stepDefinitions?.[columnId];
		const type = stepDef ? stepDef.type : '';
		const titleAttr = stepDef ? stepDef.title : '';
		let extraClasses = [];
		if (!this.allowedColumnsIdx.includes(colIdx)) {
			extraClasses.push('dp-hidden');
		}
		extraClasses.push(`acf-table-body-cell--${type}`);
		const extClassStr = extraClasses.join(' ');

		const dataVal = decodeStepParamAdvancedVal(data, columnId, this.config.stepDefinitions, false);


		if (columnId === 'hidden_meta' && dataVal?.ext?.build_with_wp_editor?.val === '1') {
			// set white spacing class
			if (jRow) jRow.find('.acf-table-body-cell--text_wp_edit .acf-table-body-cont').addClass('acf-table-body-cont--wsn');
		}

		switch (type) {
			case 'link': return this.tableHtml.body_cell_link(dataVal.val, extClassStr, dataVal.ext, rowIdx, titleAttr);
			case 'select': return this.tableHtml.body_cell_select(stepDef.options, dataVal.val, extClassStr, /*dataVal.ext,*/ titleAttr);
			case 'checkbox': return this.tableHtml.body_cell_checkbox(dataVal.val === true || dataVal.val == 1, extClassStr, dataVal.ext, titleAttr);
			default: return this.tableHtml.body_cell(dataVal.val, extClassStr, dataVal.ext, null, titleAttr);
		}
	}

	misc_render(p) {
		this.init_option_use_header(p);
		this.init_option_caption(p);
	}

	init_option_use_header(p) {
		// VARS {

		const v = {};

		v.obj_use_header = p.obj_root.find('.acf-table-fc-opt-use-header');

		// }

		// HEADER {

		// HEADER: FIELD OPTIONS, THAT AFFECTS DATA {

		// HEADER IS NOT ALLOWED

		if (p.field_options.use_header === 2) {
			p.obj_table.addClass('acf-table-hide-header');

			p.data.p.o.uh = 0;
			this.update_table_data_field(p);
		}

		// HEADER IS REQUIRED

		if (p.field_options.use_header === 1) {
			p.data.p.o.uh = 1;
			this.update_table_data_field(p);
		}

		// }

		// HEADER: SET CHECKBOX STATUS {

		if (p.data.p.o.uh === 1) {
			v.obj_use_header.val('1');
		}

		if (p.data.p.o.uh === 0) {
			v.obj_use_header.val('0');
		}

		// }

		// HEADER: SET HEADER VISIBILITY {

		if (p.data.p.o.uh === 1) {
			p.obj_table.removeClass('acf-table-hide-header');
		}

		if (p.data.p.o.uh === 0) {
			p.obj_table.addClass('acf-table-hide-header');
		}

		// }

		// }
	}

	init_option_caption(p) {
		if (
			typeof p.field_options.use_caption !== 'number'
			|| p.field_options.use_caption === 2
		) {
			return;
		}

		// VARS {

		const v = {};

		v.obj_caption = p.obj_root.find('.acf-table-fc-opt-caption');

		// }

		// SET CAPTION VALUE {

		v.obj_caption.val(p.data.p.ca);

		// }
	}


	table_add_col(p) {
		// requires
		// p.obj_col

		const that_index = p.obj_col.index();

		p.obj_root = p.obj_col.parents('.acf-table-root');
		p.obj_table = p.obj_root.find('.acf-table-table');

		$(p.obj_table.find('.acf-table-top-row').children()[that_index]).after(this.tableHtml.top_cell.replace('<!--ph-->', ''));

		$(p.obj_table.find('.acf-table-header-row').children()[that_index]).after(this.tableHtml.header_cell(''));

		p.obj_table.find('.acf-table-body-row').each((_, element) => {
			$($(element).children()[that_index]).after(this.tableHtml.body_cell());
		});

		this.table_top_labels(p);

		p.obj_table.find('.acf-table-remove-col').show();
		p.obj_table.find('.acf-table-remove-row').show();

		this.table_build_json(p);
	}

	table_add_row_event() {
		this.jBody.on('mouseup', '.acf-table-add-row', (e) => {
			e.preventDefault();
			e.stopPropagation();
			const that = $(e.target).closest('.acf-table-add-row');
			const p = {};

			p.obj_row = that.parent().parent();

			this.table_add_row(p);
			return false;
		});
	}

	table_add_first_row() {

	}



	table_add_row(p, wasRemoved = false) {
		// requires
		// p.obj_row

		let that_index = 0;
		let col_amount = 0;
		let body_cells_html = '';

		p.obj_root = p.obj_row.parents('.acf-table-root');
		p.obj_wrap = p.obj_root.find('.acf-table-wrap');
		p.obj_table = p.obj_root.find('.acf-table-table');
		p.obj_table_rows = p.obj_table.children();
		col_amount = p.obj_table.find('.acf-table-top-cell').size();
		that_index = p.obj_row.index();
		const stepIdx = that_index - 1;

		for (let i = 0; i < col_amount; i++) {
			let cellContent = null;
			const columnId = this.var.columIds[i];

			if (columnId) {
				const stepDef = this.config.stepDefinitions?.[columnId];
				cellContent = this.config.stepDefinitions[columnId] ? this.config.stepDefinitions[columnId].def : '';
				if (stepDef && stepDef.type === 'link') {
					if (stepIdx == 0 && !wasRemoved) {
						if ((stepIdx + 2) < p.obj_table_rows?.length) {
							const prevFirstStepLinkCellEl = $('#dpit-admin-first-step-link-cell').get(0);
							if (prevFirstStepLinkCellEl) {
								body_cells_html += prevFirstStepLinkCellEl.outerHTML;
								prevFirstStepLinkCellEl.outerHTML = this.get_column_html(Number(i), '$keep-prev-step-url', stepIdx + 1);
							}
						}
					} else {
						body_cells_html += this.get_column_html(Number(i), wasRemoved ? cellContent : cellContent || '$keep-prev-step-url', stepIdx);
					}
				} else {
					body_cells_html += this.get_column_html(Number(i), cellContent, stepIdx);
				}
			}
		}

		$(p.obj_table_rows[that_index])
			.after(this.tableHtml.body_row)
			.next()
			.find('.acf-table-body-left')
			.after(body_cells_html);

		this.table_left_labels(p);

		p.obj_table.find('.acf-table-remove-col').show();
		p.obj_table.find('.acf-table-remove-row').show();

		this.table_build_json(p);

		this.containerDraggers[p.obj_wrap.get(0)]?.refresh();

		$('.acf-table-sort-row-icon:not(.acf-table-sort-row-icon--loaded)')
			.load(urlJoin(this.config.assetsUrl, '/icons/arrows-alt-v-solid.svg'))
			.addClass('acf-table-sort-row-icon--loaded').fadeIn(700);
		if (this.onRowAdded instanceof Function) this.onRowAdded();
	}

	table_remove_first_row(obj_table) {
		const col_amount = obj_table.find('.acf-table-top-cell').size();
		for (let i = 0; i < col_amount; i++) {
			const columnId = this.var.columIds[i];
			if (columnId) {
				const stepDef = this.config.stepDefinitions?.[columnId];

				if (stepDef && stepDef.type === 'link') {
					const firstStepLinkCellEl = $('#dpit-admin-first-step-link-cell').get(0);
					if (firstStepLinkCellEl) {
						const secondStepLinkEl = obj_table.find('.acf-table-body-row').get(1)?.querySelector('.acf-table-body-cell--link');
						if (secondStepLinkEl) {
							secondStepLinkEl.outerHTML = firstStepLinkCellEl.outerHTML;
						}
					}
				}
			}
		}
	}

	table_remove_row() {
		this.jBody.on('click', '.acf-table-remove-row', (e) => {
			e.preventDefault();


			const that = $(e.target).closest('.acf-table-remove-row');
			let rows_count = false;

			const p = {};
			p.obj_row = that.parent().parent();
			p.obj_root = that.parents('.acf-table-root');
			p.obj_table = p.obj_root.find('.acf-table-table');
			p.obj_rows = p.obj_root.find('.acf-table-body-row');
			const stepIdx = p.obj_row.index() - 2;
			rows_count = p.obj_rows.length;

			if (stepIdx === 0) {
				this.table_remove_first_row(p.obj_table);
			}

			that.parent().parent().remove();
			p.obj_table_rows = p.obj_table.children();
			if (rows_count == 1) {

				this.table_add_row({
					obj_row: p.obj_table.find('.acf-table-header-row'),
				}, true);

				p.obj_table.find('.acf-table-remove-row').hide();
			}


			this.table_left_labels(p);

			this.table_build_json(p);
		});
	}

	table_add_link() {
		this.jBody.on('click', '.acf-table-add-link', (e) => {
			e.preventDefault();
			this.state.current_cell_obj = $(e.target).closest('.acf-table-body-cell--link');
			this.openWpLinkModal();
		});
	}

	table_remove_link() {
		this.jBody.on('click', '.acf-table-remove-link', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.triggerChangeEventOnAcfTableRoot(e.target);
			const p = {};
			const that = $(e.target).closest('.acf-table-remove-link');
			p.obj_root = that.parents('.acf-table-root');
			p.obj_table = p.obj_root.find('.acf-table-table');
			p.obj_rows = p.obj_root.find('.acf-table-body-row');
			$(e.target).closest('li').remove();
			this.table_build_json(p);
			if (this.onFirstStepUrlChangedCb) this.onFirstStepUrlChangedCb();
		});
	}


	table_top_labels(p) {
		let letter_i_1 = 'A'.charCodeAt(0);
		let letter_i_2 = 'A'.charCodeAt(0);
		let use_2 = false;

		p.obj_table.find('.acf-table-top-cont').each((_, element) => {
			let string = '';

			if (!use_2) {
				string = String.fromCharCode(letter_i_1);

				if (letter_i_1 === 'Z'.charCodeAt(0)) {
					letter_i_1 = 'A'.charCodeAt(0);
					use_2 = true;
				} else {
					letter_i_1 += 1;
				}
			} else {
				string = String.fromCharCode(letter_i_1) + String.fromCharCode(letter_i_2);

				if (letter_i_2 === 'Z'.charCodeAt(0)) {
					letter_i_1 += 1;
					letter_i_2 = 'A'.charCodeAt(0);
				} else {
					letter_i_2 += 1;
				}
			}

			$(element).text(string);
		});
	}

	table_left_labels(p) {
		let i = 0;

		p.obj_table.find('.acf-table-body-left').each((_, element) => {
			i += 1;

			$(element).find('.acf-table-body-cont').text(i);
		});
	}


	getTableBodyCellContValAtomic(type, jContItem, contItemSelector = '.acf-table-body-cont-sub') {

		switch (type) {
			case 'checkbox': return jContItem.find(contItemSelector)[0]?.checked ? '1' : '0';
			case 'number': return $(jContItem.find(contItemSelector)[0]).val();
			case 'select': return $(jContItem.find(contItemSelector)[0]).val();
			case 'link': {
				if (jContItem.parent().hasClass('acf-table-body-cell--link-multi')) {
					let resArr = [];
					const jLi = $(jContItem[0]).find('.acf-table-body-cont-li');
					if (jLi.length) {
						jLi.each((_, element) => {
							resArr.push($(element).find('span').text());
						});
					}
					return resArr.filter(n => n).join(',');
				}
				else return jContItem.html();
			}
			case 'ext_only': return '';
			default: {
				let html = jContItem.clone()    //clone the element
					.children('.acf-table-cell-ec') //select all the children with extended data
					.remove()   //remove all the children
					.end()  //again go back to selected element
					.html();
				return html;
			}

		}
	}

	getStepExtCfg(columnId) {
		return columnId && this.config.stepDefinitions[columnId] ? this.config.stepDefinitions[columnId]?.ext : null;
	}

	getTableBodyCellContVal(columnId, jContItem) {
		let res = {};
		const stepDef = this.config.stepDefinitions?.[columnId];
		const extCfg = this.getStepExtCfg(columnId);
		if (stepDef) {
			let mainVal = this.getTableBodyCellContValAtomic(stepDef.type, jContItem);
			if (extCfg) {
				const extVal = {};
				jContItem.find('.acf-cell-eci-wrap').each((_, element) => {
					const id = $(element).attr('data-id');
					if (id && extCfg[id]) {
						const type = extCfg[id].type;
						if (type) {
							extVal[id] = this.getTableBodyCellContValAtomic(type, $(element));
						}
					}
				});
				mainVal = encodeStepParamAdvancedVal({ val: mainVal, ext: extVal }, columnId, this.config.stepDefinitions);
			}
			res = mainVal;
		}
		return res;
	}



	table_build_json(p) {
		let i = 0;
		let i2 = 0;

		p.data = this.data_get(p);
		this.data_default(p);

		p.data.c = [];
		p.data.h = [];
		p.data.b = [];

		// TOP {

		i = 0;

		p.obj_table.find('.acf-table-top-cont').each((_, element) => {
			p.data.c[i] = {};
			p.data.c[i].p = $(element).parent().data('colparam');

			i += 1;
		});

		// }

		// HEADER {

		i = 0;

		p.obj_table.find('.acf-table-header-cont').each((_, element) => {
			p.data.h[i] = {};
			p.data.h[i].c = $(element).html();
			p.data.h[i].v = $(element).data('val');

			i += 1;
		});

		// }

		// BODY {

		i = 0;
		i2 = 0;

		p.obj_table.find('.acf-table-body-row').each((_, element_row) => {
			p.data.b[i] = [];

			$(element_row).find('.acf-table-body-cell .acf-table-body-cont').each((_, element) => {
				p.data.b[i][i2] = {};
				const columnId = this.var.columIds[i2];
				if (columnId) {
					p.data.b[i][i2].c = this.getTableBodyCellContVal(columnId, $(element));
				}
				i2 += 1;
			});

			i2 = 0;
			i += 1;
		});

		// }

		// UPDATE INPUT WITH NEW DATA {

		this.update_table_data_field(p);

		// }
	}

	update_table_data_field(p) {
		// UPDATE INPUT WITH NEW DATA {

		p.data = this.update_table_data_version(p.data);

		// makes json string from data object
		let data = JSON.stringify(p.data);

		// adds backslash to all \" in JSON string because encodeURIComponent() strippes backslashes
		data.replace(/\\"/g, '\\"');

		// encodes the JSON string to URI component, the format, the JSON string is saved to the database
		data = encodeURIComponent(data);

		p.obj_root.find('input.table').val(data);

		this.field_changed(p);

		// }
	}

	update_table_data_version(data) {
		if (typeof data.acftf === 'undefined') {
			data.acftf = {};
		}

		data.acftf.v = this.version;

		return data;
	}


	tmce_cell_editor() {
		this.tmce = new DpTinyMceDialog(this.config.tmce, (target, content) => {
			if (target) {

				target.html(content);
				const p = {};
				p.obj_root = target.parents('.acf-table-root');
				p.obj_table = p.obj_root.find('.acf-table-table');
				p.obj_rows = p.obj_root.find('.acf-table-body-row');
				const currentRow = target.closest('.acf-table-body-row');
				currentRow.find('.acf-cell-eci-wrap[data-id="build_with_wp_editor"] input').prop('checked', true);
				currentRow.find('.acf-table-body-cell--text_wp_edit .acf-table-body-cont').addClass('acf-table-body-cont--rt');

				this.table_build_json(p);
				this.triggerChangeEventOnAcfTableRoot(target);
			}
		}, false, this.config.dpDebugEn);
		this.jBody.on('click', '.acf-table-body-cell--text_wp_edit', (e) => {

			let jTargetContentEl = ($(e.target).hasClass('acf-table-body-cont')) ? $(e.target) : $(e.target).find('.acf-table-body-cont');
			if (!jTargetContentEl.length) jTargetContentEl = $(e.target).closest('.acf-table-body-cont');
			//console.log($(e.target), jTargetContentEl, jTargetContentEl.html());
			this.tmce.open(jTargetContentEl, jTargetContentEl.html(), this.getStepIdx($(e.target)));
		});
	}

	editor_custom_style() {

		setTextStyles(this.config?.text_styles, getWinBB());
		/*if (!$.isEmptyObject(this.config?.text_styles)) {
			this.jBody.addClass();
		}*/

	}

	openWpLinkModal($sourceEl = null, initialLinkText = '') {
		if (this.dpWpLink) {
			let text = initialLinkText;
			const stepIdx = $sourceEl ? this.getStepIdx($sourceEl) : 1;
			const urlVarExamplesStr = $('.acf-field[data-name="url_vars_examples"] textarea').val();
			let urlVarExamples = null;
			if (urlVarExamplesStr) {
				urlVarExamples = strToSimpleObject(urlVarExamplesStr, '\n');
			}
			this.dpWpLink.open(text, null, false, true, stepIdx, isUrlVariableProcessingEnabled(), urlVarExamples, this.config.sysUrlVars, $sourceEl);

			return false;
		}
	}

	link_editor() {
		this.jBody.on('click', '.acf-table-body-cell--link', (e) => {
			if (this.dpWpLink) {
				const that = $(e.target).closest('.acf-table-body-cell--link');
				this.state.current_cell_obj = that;
				let openDpWpLink = true;
				let text = '';
				let jSubEl = null;
				const content = that.find('.acf-table-body-cont');
				if (content.length) {
					const jLi = $(e.target).closest('.acf-table-body-cont-li');
					if (jLi.length) {
						jSubEl = $(jLi[0]).find('span');
						if (jSubEl.length) text = $(jSubEl[0]).text();
					}
					else if (!content.find('ul').length) {
						text = $(content[0]).text();
						jSubEl = $(content);

					}
					else {
						openDpWpLink = false;
					}
				}
				if (openDpWpLink) {
					this.openWpLinkModal(jSubEl, text);
				}
				return false;
			}
		});
	}

	simple_cell_editor() {
		this.jBody.on('click', '.acf-table-body-cell--text', (e) => {
			const $cell = $(e.target).closest('.acf-table-body-cell--text');
			const isInEditMode = $cell.find('.acf-table-cell-editor').length > 0;
			if (!isInEditMode) {
				e.stopImmediatePropagation();
				if (!$(e.target).closest('.acf-table-cell-ec').length) {
					this.cell_editor_save();
					this.cell_editor_add_editor({ that: $cell });
				}
			}
		});

		this.jBody.on('click', '.acf-table-cell-editor-textarea', (e) => {
			e.stopImmediatePropagation();
		});

		this.jBody.on('click', () => {
			this.cell_editor_save();
			return true;
		});
	}

	getStepIdx(jTarget) {
		return Number(jTarget.closest('.acf-table-body-row').find('.acf-table-body-left .acf-table-body-cont').text());
	}

	cell_editor_add_editor(p) {
		const defaults = {
			that: false,
		};

		p = $.extend(true, defaults, p);

		if (p.that) {
			this.state.current_cell_obj = p.that;

			if (p.that.hasClass('acf-table-body-cell--text')) {
				const that_val = p.that.find('.acf-table-body-cont, .acf-table-header-cont').html();
				this.state.cell_editor_is_open = true;

				p.that.append(this.tableHtml.htmleditor).find('.acf-table-cell-editor-textarea').html(that_val).focus();
				$('.acf-table-cell-editor').fadeIn();
				p.that.find('.acf-table-body-cont').addClass('dpit-hidden-hard');
				const textAreaElement = $('.acf-table-cell-editor-textarea')[0];
				autosize(textAreaElement);
				textAreaElement.focus();
				textAreaElement.setSelectionRange(textAreaElement.value.length, textAreaElement.value.length);
			}
		}
	}

	get_next_table_cell() {
		// next cell of current row
		let next_cell = this.state.current_cell_obj
			.next('.acf-table-body-cell, .acf-table-header-cell');

		// else if get next row
		if (next_cell.length === 0) {
			next_cell = this.state.current_cell_obj
				.parent()
				.next('.acf-table-body-row')
				.find('.acf-table-body-cell')
				.first();
		}

		// if next row, get first cell of that row
		if (next_cell.length !== 0) {
			this.state.current_cell_obj = next_cell;
		} else {
			this.state.current_cell_obj = false;
		}
	}

	get_prev_table_cell() {

		// prev cell of current row
		const table_obj = this.state.current_cell_obj.closest('.acf-table-table');
		const no_header = table_obj.hasClass('acf-table-hide-header');
		let prev_cell = this.state.current_cell_obj
			.prev('.acf-table-body-cell, .acf-table-header-cell');

		// else if get prev row
		if (prev_cell.length === 0) {
			const row_selectors = ['.acf-table-body-row'];

			// prevents going to header cell if table header is hidden
			if (no_header === false) {
				row_selectors.push('.acf-table-header-row');
			}

			prev_cell = this.state.current_cell_obj
				.parent()
				.prev(row_selectors.join(','))
				.find('.acf-table-body-cell, .acf-table-header-cell')
				.last();
		}

		// if next row, get first cell of that row
		if (prev_cell.length !== 0) {
			this.state.current_cell_obj = prev_cell;
		} else {
			this.state.current_cell_obj = false;
		}
	}

	rebuild_table_data(trigger) {
		const root = $(trigger).parents('.acf-table-root');
		const p = {

			obj_root: root,
			obj_table: root.find('.acf-table-table'),
		};
		this.table_build_json(p);
	}

	cell_editor_save() {
		const cell_editor = this.jBody.find('.acf-table-cell-editor');
		const cell_editor_textarea = cell_editor.find('.acf-table-cell-editor-textarea');
		const p = {};
		var cell_editor_val = '';
		$(cell_editor.prev()).removeClass('dpit-hidden-hard');
		if (typeof cell_editor_textarea.val() !== 'undefined') {
			p.obj_root = cell_editor.parents('.acf-table-root');
			p.obj_table = p.obj_root.find('.acf-table-table');

			cell_editor_val = cell_editor_textarea.val();

			// prevent XSS injection
			cell_editor_val = cell_editor_val.replace(/<(script)/ig, '&#060;$1');
			cell_editor_val = cell_editor_val.replace(/<\/(script)/ig, '&#060;/$1');

			cell_editor.prev().html(cell_editor_val);

			this.table_build_json(p);

			cell_editor.remove();
			this.state.cell_editor_is_open = false;

			p.obj_root.find('.acf-table-remove-col').show(), p.obj_root.find('.acf-table-remove-row').show();
		}

		$('.acf-table-cell-editor').fadeOut();
	}

	prevent_cell_links() {
		this.jBody.on('click', '.acf-table-body-cont a, .acf-table-header-cont a:not(.dpit-table-pro-link)', (e) => {
			e.preventDefault();
		});
	}

	sortable_fix_width(e, ui) {
		ui.children().each((_, element) => {
			const that = $(element);

			that.width(that.width());
		});

		return ui;
	}

	fixVerticalScrollTop(childEl) {
		if (childEl) {
			const tableWrap = childEl.closest('.acf-table-wrap');
			tableWrap.scrollTop = 0;
		}
	}

	sortable_row() {
		const that = this;
		const param = {
			axis: 'y',
			items: '> .acf-table-body-row',
			containment: 'parent',
			handle: '.acf-table-body-left', // .acf-table-body-cont',
			helper: this.sortable_fix_width,
			cancel: '.no-drag',
			update(event, ui) {
				// console.log(event);
				const p = {};

				p.obj_root = ui.item.parents('.acf-table-root');
				p.obj_table = p.obj_root.find('.acf-table-table');
				that.table_left_labels(p);

				that.fixVerticalScrollTop(ui.item.get(0));


				const that_index = ui.item.index();
				const stepIdx = that_index - 1;
				let prevFirstStepLinkCellEl = ui.item.find('#dpit-admin-first-step-link-cell').get(0);
				if (!prevFirstStepLinkCellEl) prevFirstStepLinkCellEl = $('#dpit-admin-first-step-link-cell').get(0);
				if (prevFirstStepLinkCellEl) {
					const columnIdx = that.var.columIds.indexOf('url');
					const firstUrlOfFirstStep = $(prevFirstStepLinkCellEl).find('.acf-table-body-cont-li').first().find('span').text();
					prevFirstStepLinkCellEl.outerHTML = that.get_column_html(columnIdx, firstUrlOfFirstStep || '$keep-prev-step-url', stepIdx);


					const newFirstStepLinkCellEl = p.obj_table.find('.acf-table-body-row').first().find('.acf-table-body-cell--link').get(0);
					if (newFirstStepLinkCellEl) {
						let textContent = newFirstStepLinkCellEl.querySelector('.acf-table-body-cont')?.textContent;
						if (textContent === '$keep-prev-step-url' || textContent === '$keep-current-url') textContent = '';
						newFirstStepLinkCellEl.outerHTML = that.get_column_html(columnIdx, textContent, 0);
					}
					if (that.onRowAdded instanceof Function) that.onRowAdded();
				}


				that.table_build_json(p);
			},
		};
		$('.acf-table-table').sortable(param);
	}



	field_changed(p) {
		if (p.field_context === 'block') {
			p.obj_root.change();
		}
	}

	sort_cols(p) {
		p.obj_table.find('.acf-table-header-row').each((_, element) => {
			p.header_row = $(element);
			p.header_row_children = p.header_row.children();

			if (p.end_index < p.start_index) {
				$(p.header_row_children[p.end_index]).before($(p.header_row_children[p.start_index]));
			}

			if (p.end_index > p.start_index) {
				$(p.header_row_children[p.end_index]).after($(p.header_row_children[p.start_index]));
			}
		});

		p.obj_table.find('.acf-table-body-row').each((_, element) => {
			p.body_row = $(element), p.body_row_children = p.body_row.children();

			if (p.end_index < p.start_index) {
				$(p.body_row_children[p.end_index]).before($(p.body_row_children[p.start_index]));
			}

			if (p.end_index > p.start_index) {
				$(p.body_row_children[p.end_index]).after($(p.body_row_children[p.start_index]));
			}
		});
	}
}